export const BC_WHATSAPP_NUM = '+5493515452364';

export const PDF_CONTRACT_TEMPLATE = {
    master: 1000,
    upgrade: 1005,
    visa:1006
};
export const CLIENT_TYPE = {
    master: 2,
    upgrade: 3,
    visa:4
}
